import React from 'react'
import { NavLink } from 'react-router-dom'
import { Icon, makeStyles, styled } from '@material-ui/core'
import { cn } from '../styles'

export const Sidebar = styled('nav')(({ theme }) => ({
  width: 64,
  minWidth: 64,
  background: theme.palette.primary.main,
  color: theme.palette.getContrastText(theme.palette.primary.main),
  display: 'flex',
  zIndex: 10,
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowX: 'hidden',
  transition: 'all ease-in-out .5s',
  transitionDelay: '.4s',

  '&:hover': {
    width: 248,
    minWidth: 248,
  },

  '& *': {
    color: '#FFF',
    listStyleType: 'none',
    whiteSpace: 'pre',
  },
}))

export const SidebarHeader = styled('header')(() => ({
  listStyleType: 'none',
  margin: 0,
  padding: '0 0 32px',
  textDecoration: 'none',
}))

export const SidebarBody = styled('ul')(() => ({
  flexGrow: 1,
  listStyleType: 'none',
  margin: 0,
  padding: '0 0 32px',
  textDecoration: 'none',
}))

export const SidebarFooter = styled('footer')(() => ({
  textDecoration: 'none',
}))

export const SidebarMenuItem = (
  { to, name, icon, small, noActive }:
  { to: string, name: string, icon?: string, small?: boolean, noActive?: boolean }
) => {
  const { navItem, navLink, navIconWrapper, navText, navItemSmall } = styles()
  return (
    <li className={cn(navItem, { [navItemSmall]: small })}>
      <NavLink exact className={navLink} to={to} activeClassName={cn({ active: noActive !== true })}>
        <Icon className={navIconWrapper} fontSize={small ? 'small' : 'default'}>{icon}</Icon>
        <span className={navText}>{name}</span>
      </NavLink>
    </li>
  )
}

const styles = makeStyles({
  navItem: {
    width: '100%',
    textAlign: 'left',
    padding: 0,
    margin: 0,
  },
  navItemSmall: {
    // margin: '12px 6px',
  },
  navIcon: {
    display: 'inline-block',
    width: 32,
    height: 32,
    margin: '0 12px 0 6px',
    background: '#FFF',
  },
  navIconWrapper: {
    margin: '24px 24px 24px 4px',
  },
  navLink: {
    color: '#FFF',
    display: 'flex',
    flexAlign: 'row',
    alignItems: 'center',
    height: 32,
    minWidth: 248,
    padding: 12,
    background: 'transparent',
    textDecoration: 'none',

    '&.active, &:hover': {
      background: '#5a1a61',
    },
  },
  navText: {
    marginLeft: 6,
    fontWeight: 'bold',
  },
})
